/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S31_Item_3Inputs */

const es_privacy_policy_data_collected_s31_item_3 = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia de perfil (URL) y preferencia de idioma`)
};

const en_privacy_policy_data_collected_s31_item_3 = /** @type {(inputs: Privacy_Policy_Data_Collected_S31_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile photo (URL) and language preference`)
};

/**
* | output |
* | --- |
* | "Profile photo (URL) and language preference" |
*
* @param {Privacy_Policy_Data_Collected_S31_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s31_item_3 = /** @type {((inputs?: Privacy_Policy_Data_Collected_S31_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S31_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s31_item_3(inputs)
	return en_privacy_policy_data_collected_s31_item_3(inputs)
});
export { privacy_policy_data_collected_s31_item_3 as "privacy_policy.data_collected.s31_item_3" }